type MapMarketProps = {
	color?: string
	className?: string
	zIndex?: boolean
}

export const MapMarker = (props: MapMarketProps) => {
	const { color = '#292424', className = `marker`, zIndex } = props

	return (
		<svg
			className={className}
			width="38"
			height="38"
			viewBox="0 0 48 58"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ zIndex: zIndex ? 3 : 1 }}
		>
			<path
				d="M48 25.375C48 46.2188 24 58 24 58C24 58 0 45.7656 0 25.375C0 11.3608 10.7452 0 24 0C37.2548 0 48 11.3608 48 25.375Z"
				fill={color}
			/>
			<path
				d="M20.5159 20.7479C25.3176 20.7479 28.0278 23.267 28.0278 28.5437L28.0297 28.5456V39.4795H22.4672V29.0207C22.4672 27.1186 21.7537 26.1684 19.8042 26.1684H16V20.7479H20.5159Z"
				fill="white"
			/>
			<path d="M22.1795 17.6572V12H27.7894V17.6572H22.1795Z" fill="white" />
		</svg>
	)
}
